import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { getInlineLoader } from "../Helpers";
import banner1 from '../assets/banner1.jpg';
import banner2 from '../assets/banner2.jpg';
import banner4 from '../assets/banner4.jpg';
import banner5 from '../assets/banner5.jpg';
import banner6 from '../assets/banner6.jpg';
import banner7 from '../assets/banner7.jpg';
import { IoMdCheckmarkCircleOutline, IoMdTrophy } from "react-icons/io";
import { FaArrowCircleRight } from "react-icons/fa";
import { GiCheckMark } from "react-icons/gi";
import logo_icon from "../assets/logo_icon.png";

export default function HomeBanner1(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ ready, setReady ] = useState(false);
	const [ bgIndex, setBgIndex ] = useState(0);
	const banners = [banner5, banner7, banner1, banner2, banner4, banner6];

	async function init() {
		setReady(false);
		// initializations...
		setReady(true);
	}

	useEffect(() => {
		init();
	}, []);

	// Background transition effect
	useEffect(() => {
		if (!ready) return;

		const interval = setInterval(() => {
			setBgIndex(prev => (prev + 1) % banners.length);
		}, 2500); // change every 5 seconds

		return () => clearInterval(interval);
	}, [ready]);

	if (ready) {
		return (
			<div className="MainBodySection">
				<div
					style={{
						width: "100%",
						height: "calc(100vh - var(--topBarHeight))",
						position: "relative",
						overflow: "hidden"
					}}
				>
					{banners.map((banner, i) => (
						<div
							key={i}
							style={{
								backgroundImage: `url(${banner})`,
								backgroundAttachment: "fixed",
								backgroundSize: "cover",
								backgroundPosition: "center",
								width: "100%",
								height: "100%",
								position: "absolute",
								top: 0,
								left: 0,
								transition: "opacity 1.5s ease-in-out",
								opacity: i === bgIndex ? 1 : 0,
							}}
						/>
					))}

					{/* gradient overlay */}
					<div
						style={{
							width: "100%",
							height: "100%",
							background: "rgba(0, 0, 0, 0.7)",
							position: "relative",
							zIndex: 1
						}}
					>
						<div className="container">
							<div className="row">
								<div className="col-12 text-center mt-5">
									<img src={logo_icon} width={150} />
								</div>
								<div 
									className="col-12 text-center"
									style={{
								}}
								>
									<h1
										className="font-bold text-light"
										style={{
											fontSize: "24px",
											paddingTop: "20px",
											textTransform: "uppercase",
										}}
									>
										Advanced IT & Telecom Infrastructure Expertise
									</h1>

									<h1
										className="font-light text-light"
										style={{
											fontSize: "16px",
											paddingTop: "10px",
											textTransform: "uppercase",
										}}
									>
										Precision-engineered solutions for enterprise performance.
									</h1>

									<div className="mt-3 pb-3">
										<button
											className="btn btn-padded btn-secondary btn-rounded"
											style={{

											}}
											onClick={() => {
												appContext.navTo({
													item: 'about_us'
												})
											}}
										>
											About Us
										</button>

										<button
											className="btn btn-padded btn-outline-light btn-rounded"
											style={{
												margin: "10px",
												
											}}
											onClick={() => {
												appContext.navTo({
													item: 'about_us'
												})
											}}
										>
											Contact Us
										</button>
									</div>

								</div>

								

							</div>
						</div>
					</div>

				</div>
			</div>
		);
	} else {
		return (
			<div className="container mSupportLoading">
				{getInlineLoader()}
			</div>
		);
	}
}
